import { render, staticRenderFns } from "./GradeListView.vue?vue&type=template&id=862d7ade&scoped=true"
import script from "./GradeListView.vue?vue&type=script&lang=js"
export * from "./GradeListView.vue?vue&type=script&lang=js"
import style0 from "./GradeListView.vue?vue&type=style&index=0&id=862d7ade&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862d7ade",
  null
  
)

export default component.exports